// Required for locale support for:
// - web: @protonapp/react-mobile-date-picker
import moment from 'moment'
import 'moment/min/locales'
import { getUserLocale } from 'utils/user-locale'

moment.locale(getUserLocale())
